export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14462.501b4948.jpg";